<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <div class="row">
    <div class="col-md-5">
      <div class="row d-flex align-items-center justify-content-center m-2 p-2">
        <div class="col-12">
          <autocomplete
            (onSelect)="selectResident($event)"
            [placeholder]="'RESIDENTS.SELECT_RESIDENT' | translate"
            [url]="_defaultService.getNoApartmentResidents.bind(_defaultService)"
            formControlName="residentId"
            inputValidator
            label="RESIDENTS.RESIDENTS"
            searchKey="search"
          >
            <ng-template #label let-item="item">
              {{ item | fullName }}
            </ng-template>
          </autocomplete>
        </div>
        <div class="col-12">
          <p-calendar
            [placeholder]="'CONTRACT.START_DATE' | translate"
            formControlName="startDate"
            inputStyleClass="form-control"
            inputValidator
            label="CONTRACT.START_DATE"
            appendTo="body"
            baseZIndex="100001"
          ></p-calendar>
        </div>
      </div>
    </div>
    <div class="col-md-7">
      <div class="row d-flex align-items-center justify-content-center m-2 p-2">
        <fieldset legend="RESIDENTS.SELECT_RESIDENT_INFO">
          <div>
            <div class="info-line d-flex justify-content-between mb-1 col-12">
              <div class="icon-label">
                <i class="la la-user me-1"></i>
                <strong>{{ 'RESIDENTS.FULL_NAME' | translate }}:</strong>
              </div>
              <div>{{ selectedResident()?.fullName }}</div>
            </div>
          </div>
          <div>
            <div class="info-line d-flex justify-content-between mb-1 col-12">
              <div class="icon-label">
                <i class="la la-id-card me-1"></i>
                <strong>{{ 'RESIDENTS.ID_CARD' | translate }}:</strong>
              </div>
              <div>{{ selectedResident()?.idCard }}</div>
            </div>
          </div>
          <div>
            <div class="info-line d-flex justify-content-between mb-1 col-12">
              <div class="icon-label">
                <i class="la la-file-invoice-dollar me-1"></i>
                <strong>{{ 'RESIDENTS.TAX_CODE' | translate }}:</strong>
              </div>
              <div>{{ selectedResident()?.taxCode }}</div>
            </div>
          </div>
          <div>
            <div class="info-line d-flex justify-content-between mb-1 col-12">
              <div class="icon-label">
                <i class="la la-envelope me-1"></i>
                <strong>{{ 'RESIDENTS.EMAIL' | translate }}:</strong>
              </div>
              <span>{{ selectedResident()?.email }}</span>
            </div>
          </div>
          <div>
            <div class="info-line d-flex justify-content-between mb-1 col-12">
              <div class="icon-label">
                <i class="la la-phone me-1"></i>
                <strong>{{ 'RESIDENTS.PHONE' | translate }}:</strong>
              </div>
              <span>{{ selectedResident()?.phone }}</span>
            </div>
          </div>
          <div>
            <div class="info-line d-flex justify-content-between mb-1 col-12">
              <div class="icon-label">
                <i class="la la-user-tag me-1"></i>
                <strong>{{ 'RESIDENTS.SOCIAL_STATUS' | translate }}:</strong>
              </div>
              <span class="badge bg-primary">{{ selectedResident()?.socialStatus | titlecase }}</span>
            </div>
          </div>
          <div>
            <div class="info-line d-flex justify-content-between mb-1 col-12">
              <div class="icon-label">
                <i class="la la-birthday-cake me-1"></i>
                <strong>{{ 'RESIDENTS.BIRTH_DATE' | translate }}:</strong>
              </div>
              <span>{{ selectedResident()?.birthDate | date }}</span>
            </div>
          </div>
          <div>
            <div class="info-line d-flex justify-content-between mb-1 col-12">
              <div class="icon-label">
                <i class="la la-credit-card me-1"></i>
                <strong>{{ 'RESIDENTS.ACCOUNT_NO' | translate }}:</strong>
              </div>
              <span>{{ selectedResident()?.accountNo }}</span>
            </div>
          </div>
          <div>
            <div class="info-line d-flex justify-content-between mb-1 col-12">
              <div class="icon-label">
                <i class="la la-home me-1"></i>
                <strong>{{ 'RESIDENTS.RENT_TYPE' | translate }}:</strong>
              </div>
              <span>{{ selectedResident()?.rentType }}</span>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
  <div class="text-end d-flex justify-content-end gap-2 mt-3">
    <p-button [disabled]="form.invalid || isPending()" styleClass="btn btn-primary d-flex" [loading]="isPending()" type="submit" [label]="'RESIDENTS.ASSIGN'|translate"></p-button>
    <button (click)="cancel()" class="btn btn-soft-primary" type="button">{{ 'CANCEL' | translate }}</button>
  </div>
</form>
